import Request from './request'

export default class stationServicesServices {
  static async getList(dataFilter) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/StationServices/advanceUser/list',
        data: {
          ...dataFilter,
        }
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve(null)
        }
      }).catch(() => {
        resolve(null)
      })
    })
  }

  static async insert(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/StationServices/advanceUser/insert',
        data
      }).then((result = {}) => {
        const { statusCode, data: responseData } = result
        if (statusCode === 200) {
          return resolve(responseData)
        } else {
          return resolve(null)
        }
      }).catch(() => {
        resolve(null)
      })
    })
  }

  static async update(data = {}) {
    return this.updateById(data)
  }

  static async updateById(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/StationServices/advanceUser/updateById',
        data
      }).then((result = {}) => {
        const { statusCode, data: responseData } = result
        if (statusCode === 200) {
          return resolve(responseData)
        } else {
          return resolve(null)
        }
      }).catch(() => {
        resolve(null)
      })
    })
  }

  static async delete(data = {}) {
    return new Promise(resolve => {
      Request.send({
        method: 'POST',
        path: '/StationServices/advanceUser/delete',
        data
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve(true)
        } else {
          return resolve(null)
        }
      }).catch(() => {
        resolve(null)
      })
    })
  }
}